module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('vue-spinner') : _vm._e(), _vm._v(" "), (_vm.notes.length) ? _c('div', {
    staticClass: "general-item-list"
  }, _vm._l((_vm.notes), function(note) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-head"
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editNoteAction(note)
        }
      }
    }, [_vm._v(_vm._s(note[note.type]))])]), _vm._v(" "), _c('div', {
      staticClass: "item-body casenote-title",
      domProps: {
        "innerHTML": _vm._s(note.note)
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "casenotes"
    }, [_c('li', [_c('div', {
      staticClass: "col1"
    }, [_c('div', {
      staticClass: "cont"
    }, [_c('div', {
      staticClass: "cont-col2"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(note.createdAt.date)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col2"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(note.createdBy.fullName))])])])])])
  }), 0) : _c('div', [_c('p', [_vm._v("No records available.")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e5d02a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Participant/CommunicationNotes.vue
// module id = 1597
// module chunks = 1